export class FWPauseAdSTVParams {
    #params;
    #paramsOverride = {
        asnw: '',
        caid: '',
        csid: '',
        flag: '',
        metr: '',
        nw: '',
        prof: '',
        pvrn: '',
        resp: '',
        ssnw: '',
        vprn: ''
    };
    #excludedParams = [
        'nextShowsIdsArray',
        'ifa',
        'cust_params'
    ];
    constructor(tag) {
        const utils = window.SmartTag.utilities;
        const prefix = 'imafw_';
        this.#params = {
            ...(tag?.params?.CONTENT?.resource?.ad?.ssai?.adParameters
                ?? tag?.controller?.playerManager?.currentResource?.ad?.ssai?.adParameters)
        };
        this.#excludedParams.forEach((key) => {
            if (this.#params?.[key]
                &&
                    !utils.Type.isEmpty(this.#params[key])) {
                delete this.#params[key];
            }
        });
        Object.entries(this.#paramsOverride).forEach(([key, value]) => {
            if (this.#params?.[key]
                &&
                    !utils.Type.isEmpty(this.#params[key])) {
                this.#paramsOverride[key] = this.#params[key];
                delete this.#params[key];
            }
            const prefixedKey = prefix + key;
            if (this.#params?.[prefixedKey]
                &&
                    !utils.Type.isEmpty(this.#params[prefixedKey])) {
                this.#paramsOverride[key] = this.#params[prefixedKey];
                delete this.#params[prefixedKey];
            }
        });
        const didKey = '_fw_did';
        const prefixedDidKey = prefix + didKey;
        if ((!this.#params?.[didKey] || utils.Type.isEmpty(this.#params?.[didKey]))
            &&
                (!this.#params?.[prefixedDidKey] || utils.Type.isEmpty(this.#params?.[prefixedDidKey]))) {
            const rdid = this.#params?.['rdid'] || this.#params?.[prefix + 'rdid'];
            const idtype = this.#params?.['idtype'] || this.#params?.[prefix + 'idtype'];
            this.#params['_fw_did'] = `${idtype}:${rdid}`;
        }
    }
    get paramsOverride() {
        return this.#paramsOverride;
    }
    get params() {
        return this.#params;
    }
}
